function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1212 0.414437L0.69349 11.8421C0.107703 12.4279 0.107704 13.3777 0.69349 13.9635C1.27928 14.5492 2.22902 14.5492 2.81481 13.9635L2.85216 13.9261L4.73161 15.8056C6.03083 17.1048 7.893 17.6694 9.69498 17.3105L10.8487 17.0808C11.0692 17.0368 11.2971 17.106 11.4561 17.265C11.6151 17.424 11.6842 17.6519 11.6403 17.8724L11.4105 19.0261C11.0516 20.8281 11.6163 22.6902 12.9155 23.9894L16.5153 27.5892L18.6366 25.4679L17.6261 24.4574L22.0196 19.7086H14.3355C14.3406 19.6764 14.3463 19.6442 14.3527 19.6121L14.5825 18.4584C14.8222 17.2549 14.4451 16.0113 13.5774 15.1436C12.7098 14.276 11.4661 13.8989 10.2627 14.1386L9.10901 14.3683C8.28993 14.5314 7.44349 14.2748 6.85293 13.6842L4.97348 11.8048L11.8621 4.91617L13.7419 6.79596C14.3324 7.38651 14.5891 8.23295 14.426 9.05203L14.1962 10.2057C13.9565 11.4092 14.3336 12.6528 15.2013 13.5205C16.069 14.3881 17.3126 14.7652 18.516 14.5255L19.6697 14.2958C20.4888 14.1326 21.3352 14.3893 21.9258 14.9798L25.5256 18.5796L27.6469 16.4583L24.0471 12.8585C22.7479 11.5593 20.8857 10.9947 19.0837 11.3535L17.93 11.5833C17.7095 11.6272 17.4816 11.5581 17.3226 11.3991C17.1636 11.2401 17.0945 11.0122 17.1384 10.7917L17.3682 9.638C17.7271 7.83603 17.1624 5.97385 15.8632 4.67464L13.9834 2.79485L14.2425 2.53576C14.8283 1.94997 14.8283 1.00022 14.2425 0.414438C13.6567 -0.171349 12.707 -0.171349 12.1212 0.414437Z",
  fill: "#DCD8E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.4636 15.7621L16.0359 27.1898",
  stroke: "#DCD8E5",
  strokeWidth: 3,
  strokeLinecap: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 29,
  fill: "white"
})));

var SvgHourglass = function SvgHourglass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHourglass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hourglass.ac89890c.svg";
export { ForwardRef as ReactComponent };